import UpgradePlanModal from "app/components/upgrade_plan_modal"
import { useState, useCallback, useEffect, useRef } from "react"
import { createPortal } from "react-dom"

interface Props {
  currentTier: string
  isTrialing: boolean
  proPlusProductId: string
  subscriptionPaymentType: string
}

const BillingSwitchPlanLink = ({ currentTier, isTrialing, proPlusProductId, subscriptionPaymentType }: Props) => {
  const [showModal, setShowModal] = useState(false)
  const containerRef = useRef<HTMLSpanElement>(null)

  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  }, [showModal])

  const onSwitchLinkClick = (evt: MouseEvent) => {
    evt.preventDefault()
    toggleModal()
  }

  // Make the parent .footer-upsell--dark fully clickable
  useEffect(() => {
    const upsell = containerRef.current?.closest(".footer-upsell--dark") as HTMLElement | null
    if (!upsell) return

    const handleUpsellClick = (evt: Event) => {
      const target = evt.target as HTMLElement
      if (target.tagName === "A" || target.tagName === "BUTTON") return
      setShowModal(true)
    }

    upsell.addEventListener("click", handleUpsellClick)
    return () => upsell.removeEventListener("click", handleUpsellClick)
  }, [])

  return (
    <span ref={containerRef}>
      <a onClick={onSwitchLinkClick} className="button-upsell">
        Upgrade to Pro+
      </a>
      {createPortal(
        <UpgradePlanModal
          onClose={() => setShowModal(false)}
          onUpgrade={() => window.location.reload()}
          proPlusProductId={proPlusProductId}
          step="plan_upgrade"
          tierRequirement="pro"
          trackLocation="Settings"
          user={{
            eligibleForTrial: false,
            eligibleTrialPeriod: 0,
            isTrialing,
            subscriptionPaymentType,
            tier: currentTier,
          }}
          visible={showModal}
        />,
        document.body
      )}
    </span>
  )
}

export default BillingSwitchPlanLink
